import React from 'react';
import './LoaderComponent.css';
import { Card, styled } from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows.heavy,
}));

const LoaderComponent = () => {
  return (
    <StyledCard sx={{ justifyContent: 'center', height: '100%' }}>
      <div className="road-wrapper">
        <div className="road-scene">
          <div className="sky">
            <div className="cloud cloud1" />
            <div className="cloud cloud2" />
          </div>

          <div className="road">
            <div className="lane lane1" />
            <div className="lane lane2" />
            <div className="lane lane3" />
          </div>

          <div className="sign sign-stop" />
          <div className="sign sign-speed" />

          <div className="car">
            <div className="car-body" />
            <div className="wheel front" />
            <div className="wheel back" />
          </div>

          <h3 className="loader-text">
            Capturing signs from your drive
            <span className="dots" />
          </h3>
        </div>
      </div>
    </StyledCard>
  );
};

export default LoaderComponent;
